import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { appTheme } from "./themes/theme";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_sv from "./translations/sv/common.json";
import common_ca from "./translations/ca/common.json";
import LngDetector from "i18next-browser-languagedetector";
import AppContext from "./components/AppContext/AppContext";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import Box from "@mui/material/Box";
import * as React from "react";
import { ROUTES } from "./routes";
import HomePage from "./pages/home";
import StatusPage from "./pages/status";
import { useState } from "react";
import UserDashboardPage from "./pages/user-dashboard";
import { apiUserMe } from "./api";
import UserLoginPage from "./pages/user-login";
import UserJoinPage from "./pages/user-join";
import UserPasswordPage from "./pages/user-password";
import UserVerifyPage from "./pages/user-verify";
import CalendarEventPage from "./pages/calendar-event";
import CalendarPage from "./pages/calendar";
import AboutBylawsPage from "./pages/about-bylaws";
import AboutTeamPage from "./pages/about-team";
import AboutContactPage from "./pages/about-contact";
import UserConsentPage from "./pages/user-consent";
import NewsPostPage from "./pages/news-post";
import PolicyPrivacyPage from "./pages/policy-privacy";
import PolicyPurchasePage from "./pages/policy-purchase";
import ActivityKidsPage from "./pages/activity-kids";
import ActivityDinnersPage from "./pages/activity-dinners";
import ActivityLunchesPage from "./pages/activity-lunches";
import ResourcesNewslettersPage from "./pages/resources-newsletters";
import ResourcesReportsPage from "./pages/resources-reports";
import ResourcesTransparencyPage from "./pages/resources-transparency";
import MembershipPage from "./pages/membership";
import MembershipPaymentPage from "./pages/membership-payment";
import MembershipReceiptPage from "./pages/membership-receipt";
import CoursePaymentPage from "./pages/course-payment";
import CourseReceiptPage from "./pages/course-receipt";
import RequestPaymentPage from "./pages/request-payment";
import RequestReceiptPage from "./pages/request-receipt";
import CalendarEventPaymentPage from "./pages/calendar-event-payment";
import CalendarEventReceiptPage from "./pages/calendar-event-receipt";
import AdminPage from "./pages/admin";
import AdminEventTokenPage from "./pages/admin-event-token";
import AdminEventAttendancePage from "./pages/admin-event-attendance";
import PaymentRequestPage from "./pages/payment-request";
import ErrorNotFoundPage from "./pages/error-not-found";

i18next.use(LngDetector).init({
  interpolation: { escapeValue: false },
  fallbackLng: "ca",
  load: "languageOnly",
  resources: {
    sv: {
      common: common_sv,
    },
    ca: {
      common: common_ca,
    },
  },
});

const App = () => {
  const [user, setUser] = useState(undefined);
  const [messages, setMessages] = useState(undefined);
  const [familyMemberRequests, setFamilyMemberRequests] =
    React.useState(undefined);
  const [familyMemberRequestsReceived, setFamilyMemberRequestsReceived] =
    React.useState(undefined);
  const [cart, setCart] = React.useState<{
    [key: string]: [number, object];
  }>({});
  const [order, setOrder] = useState(undefined);

  React.useEffect(() => {
    apiUserMe().then((response) => {
      if (response.status === 200) {
        setUser(response.data);
      } else if (response.status === 204) {
        setUser(null);
      }
    });
  }, [setUser]);

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
        messages,
        setMessages,
        familyMemberRequests,
        setFamilyMemberRequests,
        familyMemberRequestsReceived,
        setFamilyMemberRequestsReceived,
        cart,
        setCart,
        order,
        setOrder,
      }}
    >
      <ThemeProvider theme={appTheme}>
        <I18nextProvider i18n={i18next}>
          <BrowserRouter>
            <Box
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                overflowX: "hidden",
              }}
            >
              <NavBar />
              <Box style={{ flexGrow: 1, position: "relative" }}>
                <Routes>
                  <Route path={ROUTES.home.path} element={<HomePage />} />
                  <Route path={ROUTES.status.path} element={<StatusPage />} />
                  <Route
                    path={ROUTES["user-login"].path}
                    element={<UserLoginPage />}
                  />
                  <Route
                    path={ROUTES["user-join"].path}
                    element={<UserJoinPage />}
                  />
                  <Route
                    path={ROUTES["user-password"].path}
                    element={<UserPasswordPage />}
                  />
                  <Route
                    path={ROUTES["user-set-password"].path}
                    element={<UserPasswordPage />}
                  />
                  <Route
                    path={ROUTES["user-set-verify"].path}
                    element={<UserVerifyPage />}
                  />
                  <Route
                    path={ROUTES["user-dashboard"].path}
                    element={<UserDashboardPage />}
                  />
                  <Route
                    path={ROUTES["user-consent"].path}
                    element={<UserConsentPage />}
                  />
                  <Route
                    path={ROUTES["calendar"].path}
                    element={<CalendarPage />}
                  />
                  <Route
                    path={ROUTES["calendar-event"].path}
                    element={<CalendarEventPage />}
                  />
                  <Route
                    path={ROUTES["calendar-event-signup"].path}
                    element={<CalendarEventPage />}
                  />
                  <Route
                    path={ROUTES["calendar-event-payment"].path}
                    element={<CalendarEventPaymentPage />}
                  />
                  <Route
                    path={ROUTES["calendar-event-receipt"].path}
                    element={<CalendarEventReceiptPage />}
                  />
                  <Route
                    path={ROUTES["about-bylaws"].path}
                    element={<AboutBylawsPage />}
                  />
                  <Route
                    path={ROUTES["about-team"].path}
                    element={<AboutTeamPage />}
                  />
                  <Route
                    path={ROUTES["about-contact"].path}
                    element={<AboutContactPage />}
                  />
                  <Route
                    path={ROUTES["news-post"].path}
                    element={<NewsPostPage />}
                  />
                  <Route
                    path={ROUTES["policy-privacy"].path}
                    element={<PolicyPrivacyPage />}
                  />
                  <Route
                    path={ROUTES["activity-kids"].path}
                    element={<ActivityKidsPage />}
                  />
                  <Route
                    path={ROUTES["activity-dinners"].path}
                    element={<ActivityDinnersPage />}
                  />
                  <Route
                    path={ROUTES["activity-lunches"].path}
                    element={<ActivityLunchesPage />}
                  />
                  <Route
                    path={ROUTES["resources-newsletters"].path}
                    element={<ResourcesNewslettersPage />}
                  />
                  <Route
                    path={ROUTES["resources-reports"].path}
                    element={<ResourcesReportsPage />}
                  />
                  <Route
                    path={ROUTES["resources-transparency"].path}
                    element={<ResourcesTransparencyPage />}
                  />
                  <Route
                    path={ROUTES.membership.path}
                    element={<MembershipPage />}
                  />
                  <Route
                    path={ROUTES["membership-payment"].path}
                    element={<MembershipPaymentPage />}
                  />
                  <Route
                    path={ROUTES["membership-receipt"].path}
                    element={<MembershipReceiptPage />}
                  />
                  <Route
                    path={ROUTES["course-payment"].path}
                    element={<CoursePaymentPage />}
                  />
                  <Route
                    path={ROUTES["course-receipt"].path}
                    element={<CourseReceiptPage />}
                  />
                  <Route
                    path={ROUTES["request-payment"].path}
                    element={<RequestPaymentPage />}
                  />
                  <Route
                    path={ROUTES["request-receipt"].path}
                    element={<RequestReceiptPage />}
                  />
                  <Route
                    path={ROUTES["payment-request"].path}
                    element={<PaymentRequestPage />}
                  />
                  <Route
                    path={ROUTES["policy-purchase"].path}
                    element={<PolicyPurchasePage />}
                  />
                  <Route path={ROUTES.admin.path} element={<AdminPage />} />
                  <Route
                    path={ROUTES["admin-event-token"].path}
                    element={<AdminEventTokenPage />}
                  />
                  <Route
                    path={ROUTES["admin-event-attendance"].path}
                    element={<AdminEventAttendancePage />}
                  />
                  <Route path="*" element={<ErrorNotFoundPage />} />
                </Routes>
              </Box>
              <Footer />
            </Box>
          </BrowserRouter>
        </I18nextProvider>
      </ThemeProvider>
    </AppContext.Provider>
  );
};

export default App;
